'use client';

import Link from 'next/link';
import classes from './TextCard.module.scss';
import { Button, Container } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

type TextCardProps = {
  title: string;
  description: string;
  button?: string;
  buttonColor?: string;
  buttonHref?: string;
};

export const TextCard = ({ data }: { data: TextCardProps }) => {
  const dictionary = useDictionary();
  const { title, description, button, buttonColor, buttonHref } = data;

  return (
    <div className={classes.wrapper}>
      <Container>
        <section className={classes.horizontalSection}>
          <h2>{title}</h2>
          <img
            src={dictionary.separateur}
            alt="Separation"
            className={`${classes.horizontalSectionDivider} mb-5`}
          />
          <p>{description}</p>
          {button && (
            <Button className={classes.button} component={Link} href={buttonHref ?? ''}>
              {button}
            </Button>
          )}
        </section>
      </Container>
    </div>
  );
};
